/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Insufficientcredits_Title1Inputs */

const zh_chat_insufficientcredits_title1 = /** @type {(inputs: Chat_Insufficientcredits_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分不足`)
};

const en_chat_insufficientcredits_title1 = /** @type {(inputs: Chat_Insufficientcredits_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insufficient Credits`)
};

const es_chat_insufficientcredits_title1 = /** @type {(inputs: Chat_Insufficientcredits_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créditos insuficientes`)
};

/**
* | output |
* | --- |
* | "Insufficient Credits" |
*
* @param {Chat_Insufficientcredits_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_insufficientcredits_title1 = /** @type {((inputs?: Chat_Insufficientcredits_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Insufficientcredits_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_insufficientcredits_title1(inputs)
	if (locale === "en") return en_chat_insufficientcredits_title1(inputs)
	return es_chat_insufficientcredits_title1(inputs)
});
export { chat_insufficientcredits_title1 as "chat_insufficientCredits_title" }